var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCirclesOverlap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 29,
    viewBox: "0 0 36 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.416 16.25C11.416 11.2188 14.4785 6.89844 18.8535 4.98438C17.2129 3.83594 15.2441 3.125 13.166 3.125C7.80664 3.125 3.54102 7.44531 3.54102 12.75C3.54102 18.0547 7.75195 22.3203 13.0566 22.375C11.9629 20.5703 11.416 18.4922 11.416 16.25ZM13.166 25C6.38477 25 0.916016 19.5312 0.916016 12.75C0.916016 6.02344 6.38477 0.5 13.166 0.5C16.5566 0.5 19.6191 1.92188 21.8613 4.16406C22.4082 4.05469 23.0098 4 23.666 4C30.3926 4 35.916 9.52344 35.916 16.25C35.916 23.0312 30.3926 28.5 23.666 28.5C20.2207 28.5 17.1582 27.1328 14.916 24.8906C14.3691 25 13.7676 25 13.166 25ZM23.666 25.875C28.9707 25.875 33.291 21.6094 33.291 16.25C33.291 11 29.0254 6.73438 23.7754 6.625C24.8145 8.42969 25.416 10.5625 25.416 12.75C25.416 17.8359 22.3535 22.1562 17.9785 24.0156C19.5645 25.2188 21.5332 25.875 23.666 25.875Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesOverlap);
export default __webpack_public_path__ + "static/media/circles-overlap.8668e648bb1922e4d3a156b119ae62b9.svg";
export { ForwardRef as ReactComponent };